import React from 'react';
import { type Control, Controller, type FieldErrors, type RegisterOptions } from 'react-hook-form';
import type { OidcFormBaseData, OidcFormData, OidcFormFillableData } from './OidcComponent';

interface OidcFormInputFieldProps {
  name: keyof Omit<OidcFormData, 'oidcIsManualConfig' | 'oidcRedirectUriIsManualConfig'>;
  label: string;
  type?: 'text' | 'password';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<OidcFormData, any, OidcFormData>;
  errors: FieldErrors<OidcFormData>;
  disabled?: boolean;
  rules?:
    | Omit<
        RegisterOptions<OidcFormData, keyof OidcFormBaseData | keyof OidcFormFillableData>,
        'disabled' | 'setValueAs' | 'valueAsNumber' | 'valueAsDate'
      >
    | undefined;
  onChange?: (value: string) => void;
  validationStatus?: string;
  validationErrors?: string[];
  validationWarnings?: string[];
}

export const OidcFormInputField: React.FC<OidcFormInputFieldProps> = ({
  name,
  label,
  type = 'text',
  control,
  errors,
  disabled = false,
  rules = {},
  onChange,
  validationStatus,
  validationErrors = [],
  validationWarnings = [],
}) => {
  return (
    <>
      <label htmlFor={String(name)}>{label}</label>
      <div className="input">
        <Controller
          control={control}
          name={name}
          disabled={disabled}
          rules={rules}
          render={({ field: { value, onChange: inputOnChange, onBlur } }) => (
            <input
              value={value || ''}
              disabled={disabled}
              id={String(name)}
              type={type}
              onBlur={onBlur}
              onChange={(e) => {
                onChange?.(e.target.value);
                inputOnChange(e.target.value);
              }}
            />
          )}
        />
        {errors[name] && <span>{errors[name].message}</span>}
        {validationStatus && <span className="status">{validationStatus}</span>}
        {validationErrors.map((msg) => (
          <span key={msg} className="error">
            {msg}
          </span>
        ))}
        {validationWarnings.map((msg) => (
          <span key={msg} className="warning">
            {msg}
          </span>
        ))}
      </div>
    </>
  );
};
